import {
  FaBroom,
  FaBuilding,
  FaLeaf,
  FaTruckRampBox,
  FaShield,
  FaScrewdriverWrench,
} from "react-icons/fa6";

export const site = {
  brand: "Crown Star Facility Services",
  tagline: "Beyond Cleaning. Defined by Excellence.",
  locationLine: "crownstar.com.au • Western Australia • Premium Facility Services",
  phone: " 0492 279 339",
  email: "info@crownstar.com.au",
  address: "Western Australia, Australia",
  socials: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
  images: {
    hero: "/images/hero2.jpg",
    hero2: "/images/hero1.jpg",
    about: "/images/about1.webp",
    contact: "/images/contact.jpg",
  },
};

export const services = [
  {
    icon: FaBroom,
    title: "Premium Residential Care",
    desc: "High-end residential cleaning delivered with precision, discretion, and consistently superior presentation.",
    image: "/images/service1.jpg",
  },
  {
    icon: FaBuilding,
    title: "Corporate & Commercial Facilities",
    desc: "Corporate-grade cleaning for offices, commercial towers, and shared spaces—structured systems, refined results.",
    image: "/images/service2.png",
  },
  {
    icon: FaScrewdriverWrench,
    title: "Deep Cleaning & Detail Refresh",
    desc: "Thorough top-to-bottom resets for kitchens, bathrooms, and high-use areas perfect for seasonal refreshes and premium presentation.",
    image: "/images/service8.jpg",
  },
  {
    icon: FaTruckRampBox,
    title: "Post-Construction & Handover",
    desc: "Professional site cleanup and fine-detail finishing for safe, presentable, operationally ready environments.",
    image: "/images/service4.png",
  },
  {
    icon: FaLeaf,
    title: "Grounds & External Presentation",
    desc: "Outdoor presentation, common-area care, and pressure cleaning to maintain premium standards from the outside in.",
    image: "/images/service7.jpg",
  },
  {
    icon: FaShield,
    title: "Hygiene, Sanitisation & Compliance",
    desc: "Hygienic maintenance with risk-aware processes—aligned with Australian workplace health, safety, and environmental standards.",
    image: "/images/service6.png",
  },
];

export const projects = Array.from({ length: 29 }, (_, i) => {
  const n = i + 1;
  return {
    title: `Gallery ${n}`,
    category: "Cleaning",
    src: `/images/gallery/${n}.jpg`,
  };
});

export const team = [
  { name: "Operations Lead", role: "Quality Systems & Delivery", src: "/images/project-1.jpg" },
  { name: "Site Supervisor", role: "Compliance & Service Oversight", src: "/images/project-2.jpg" },
  { name: "Service Specialist", role: "Detail & Hygiene Standards", src: "/images/project-3.jpg" },
];

export const testimonials = [
  {
    name: "Sarah M.",
    role: "Facilities Manager",
    quote:
      "We’ve used Crown Star for several months and the standard is consistently high. They follow a clear checklist, communicate well, and our common areas and amenities stay presentation-ready every day.",
  },
  {
    name: "Daniel K.",
    role: "Office Manager",
    quote:
      "Reliable and professional team. They’re discreet during business hours, handle high-touch areas properly, and the washrooms and kitchen are always maintained to a corporate-grade standard.",
  },
  {
    name: "Melissa R.",
    role: "Residential Client",
    quote:
      "Very detail-focused and respectful in the home. Bathrooms, glass, and floors are finished beautifully, and they take care around fixtures and surfaces. It feels genuinely premium after each visit.",
  },
  {
    name: "James T.",
    role: "End of Lease Clean",
    quote:
      "The end-of-lease clean was thorough and well organised. They covered everything we asked for, including the tough areas, and the place looked inspection-ready. Great communication from start to finish.",
  },
  {
    name: "Priya S.",
    role: "Property Manager (South Perth)",
    quote:
      "Consistent results across multiple properties. Easy to schedule, good reporting, and they handle issues quickly. The team works with a strong compliance mindset which makes our job much easier.",
  },
  {
    name: "Michael B.",
    role: "Builder / Site Supervisor",
    quote:
      "Excellent post-construction clean. Dust removal was done properly, surfaces were finished to a high standard, and the handover was smooth. They were punctual and worked efficiently to our timeline.",
  },
];


export const blogs = [
  {
    title: "Premium facility standards: what ‘clean’ should really mean",
    date: "Standards",
    src: "/images/blog-1.jpg",
  },
  {
    title: "Hygiene & compliance in corporate environments",
    date: "Compliance",
    src: "/images/blog-2.jpg",
  },
  {
    title: "Sustainability with purpose: a smarter way to maintain spaces",
    date: "Green Clean",
    src: "/images/blog-3.jpg",
  },
];

export const pricingTabs = [
  {
    key: "residential",
    label: "Residential",
    points: [
      "Premium residential maintenance programs",
      "Detail-focused kitchens, bathrooms, living areas",
      "Tailored scope based on your environment and expectations",
    ],
  },
  {
    key: "commercial",
    label: "Commercial",
    points: [
      "Corporate-grade cleaning schedules for workplaces",
      "High-touch hygiene, restrooms, shared areas, floors",
      "Service plans aligned with traffic and operational needs",
    ],
  },
  // {
  //   key: "endoflease",
  //   label: "End of Lease",
  //   points: [
  //     "Meticulous reset clean for handover readiness",
  //     "Finishing standards focused on presentation and hygiene",
  //     "Optional add-ons based on condition and scope",
  //   ],
  // },
];
